module.exports = __webpack_public_path__ + "img/customers-active.8f4da8d4.svg";